import { ref } from "vue";
import { listTemplates } from "./api";

/**
 * Shared template-picker state for MessageFormView and QRNoticesView.
 */
export function useTemplates(onError) {
  const templates = ref([]);
  const templatesOpen = ref(false);
  const templatesLoading = ref(false);

  async function openTemplates() {
    templatesOpen.value = true;
    templatesLoading.value = true;
    try {
      templates.value = await listTemplates();
    } catch {
      if (onError) onError("Couldn't load templates.");
      templatesOpen.value = false;
    } finally {
      templatesLoading.value = false;
    }
  }

  function closeTemplates() {
    templatesOpen.value = false;
  }

  return {
    templates,
    templatesOpen,
    templatesLoading,
    openTemplates,
    closeTemplates,
  };
}
